import { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Btn, Field, inputCls } from "@/components/kit";
import { LifeBuoy, Send, Phone, Mail } from "lucide-react";

export default function Support() {
  const { user } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      toast.error("Veuillez saisir un message");
      return;
    }
    setLoading(true);
    try {
      await api.post("/support/contact", { name, message });
      toast.success("Message envoyé au support. Nous vous répondrons rapidement.");
      setMessage("");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-2xl" data-testid="support-page">
      <div className="mb-6 flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center bg-secondary text-primary">
          <LifeBuoy size={20} />
        </div>
        <div>
          <h2 className="font-display text-xl font-bold tracking-tight">Contacter le support</h2>
          <p className="text-sm text-muted-foreground">
            Une question ou un souci ? Écrivez-nous, notre équipe vous répond au plus vite.
          </p>
        </div>
      </div>

      <form onSubmit={submit} className="space-y-4 border border-border bg-card p-6" data-testid="support-form">
        <Field label="Votre nom">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Votre nom"
            className={inputCls}
            data-testid="support-name-input"
          />
        </Field>
        <Field label="Votre message">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={6}
            required
            placeholder="Décrivez votre demande…"
            className={`${inputCls} resize-y`}
            data-testid="support-message-input"
          />
        </Field>
        <div className="flex items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">
            Envoyé depuis <span className="font-medium text-foreground">{user?.email}</span>
          </p>
          <Btn type="submit" loading={loading} data-testid="support-submit-btn">
            <Send size={16} /> Envoyer
          </Btn>
        </div>
      </form>

      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        <a
          href="tel:+33676277087"
          className="flex items-center gap-3 border border-border bg-card p-4 text-sm transition-colors hover:border-primary"
          data-testid="support-phone"
        >
          <Phone size={18} className="text-primary" />
          <span>+33 6 76 27 70 87</span>
        </a>
        <a
          href="mailto:maelgrgr@gmail.com"
          className="flex items-center gap-3 border border-border bg-card p-4 text-sm transition-colors hover:border-primary"
          data-testid="support-email"
        >
          <Mail size={18} className="text-primary" />
          <span>maelgrgr@gmail.com</span>
        </a>
      </div>
    </div>
  );
}
